module.exports = __webpack_public_path__ + "img/pakistan.d5e627b0.png";